import { Flex } from 'antd'
import imageIntegration from '@/assets/img/solution/school-bus/integration.png'
import Image from '@/components/image'
import Styles from './style.module.scss'

interface TextItemProps {
  title: string
  descriptions: string[]
}

const TITLE = 'Integrated Green Energy Solution'
const data: TextItemProps[] = [
  {
    title: 'Solar PV Options',
    descriptions: ['Rooftop, Carport, BIPV Solar Tiles\n(~600 kWh/day generation)'],
  },
  {
    title: 'ESS Support',
    descriptions: [
      'Peak shaving & electricity cost savings',
      'Backup power for critical school operations',
      'Revenue from Virtual Power Plant (VPP) & carbon credits',
    ],
  },
]

export function TextContent({ data }: { data: TextItemProps[] }) {
  return (
    <Flex vertical className={Styles.textWrapper}>
      {data.map(item => (
        <Flex vertical key={item.title} className={Styles.item}>
          <div className={Styles.title}>{item.title}</div>
          {item.descriptions.map(item => (
            <div key={item} className={Styles.description}>
              {item}
            </div>
          ))}
        </Flex>
      ))}
    </Flex>
  )
}

export default function Integration() {
  return (
    <div className={Styles.integration}>
      <h2>{TITLE}</h2>
      <Flex className={Styles.content}>
        <Image src={imageIntegration} alt='integration' rootClassName={Styles.image} />
        <TextContent data={data} />
      </Flex>
    </div>
  )
}
